import React from 'react';
import { translate } from '../Services/translation';
import { useEffect, useState } from 'react';

const TableOfContents = props => {
    // Keep track of headers on product page
    const [propertiesActive, setPropertiesActive] = useState(false);
    const accordionHeader = document.getElementById('properties-accordion');
    const links = document.querySelectorAll('.c-anchorlinks__link');
    const infoTabs = document.querySelectorAll('.info-tab-container');

    // Listens to scroll on product page to update class on TOC list
    function updateActiveSection() {
        const scrollTop = window.scrollY;

        let activeSection = null;

        for (let i = 0; i < infoTabs.length; i++) {
            const section = infoTabs[i];
            const link = links[i];
            const sectionTop = section.offsetTop;
            const sectionBottom = sectionTop + section.clientHeight;

            if (
                scrollTop >= sectionTop - 200 &&
                scrollTop < sectionBottom - 200
            ) {
                activeSection = link;
                break;
            }
        }

        if (activeSection) {
            links.forEach(li =>
                li.classList.remove('c-anchorlinks__link--active'),
            );
            activeSection.classList.add('c-anchorlinks__link--active');
        }
    }

    window.addEventListener('scroll', updateActiveSection);

    if (propertiesActive && props.isMobile != true) {
        updateActiveSection();
    }

    accordionHeader.addEventListener('click', () => {
        setPropertiesActive(!propertiesActive);
    });

    // Toggles tabs on product page and scroll to view when clicking corresponding link i table
    const handleLiItemClick = index => {
        const tabNumber = index + 1;
        const isMobile = props.isMobile;

        const event = new CustomEvent('tableOfContentsItemClick', {
            detail: {
                tab: tabNumber,
                mobile: isMobile,
            },
        });

        if (!accordionHeader.classList.contains('active')) {
            setPropertiesActive(!propertiesActive);
        }

        document.dispatchEvent(event);
    };
    return props.isMobile === true ? (
        <ul>
            {props.tabs.map((tab, index) => (
                <li
                    href={index + 1}
                    className="c-anchorlinks__link_mobile"
                    key={`${tab}table`}
                    onClick={() => handleLiItemClick(index)}
                >
                    <a>
                        <span>{tab}</span>
                    </a>
                </li>
            ))}
        </ul>
    ) : (
        <nav
            className="c-anchorlinks"
            aria-labelledby="anchorLinkHeading"
            role="application"
        >
            <h2 id="anchorLinkHeading">
                {translate('tableofcontents.header')}
            </h2>
            <ul>
                {props.tabs.map((tab, index) => (
                    <li
                        href={index + 1}
                        className="c-anchorlinks__link"
                        key={`${tab}table`}
                        onClick={() => handleLiItemClick(index)}
                    >
                        <a>
                            <span>{tab}</span>
                        </a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default TableOfContents;
